/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useRef } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useParams, useHistory, useLocation, Link, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Socket.io]
-------------------------------------------------------------------*/
import io from "socket.io-client";
/*------------------------------------------------------------------
[End Socket.io]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_URL, API_SERVER, API_SCT } from '../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
import CurrencyFormat from 'react-currency-format';
import Tour from 'reactour'
import { CopyToClipboard } from "react-copy-to-clipboard"
import Peer from "simple-peer"
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Route JSON]
-------------------------------------------------------------------*/
import { route, route_name } from "./@api.json";
/*------------------------------------------------------------------
[End Route JSON]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev, console_dev_line } from '../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import ComponentsCredit from './@components/credit'
import OverlayBg from '../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Veriable]
-------------------------------------------------------------------*/
let SOCKET_SERVER = process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_SOCKET_SERVER_DEVELOPMENT : process.env.REACT_APP_SOCKET_SERVER_PRODUCTION;
let socket = io(SOCKET_SERVER);
/*------------------------------------------------------------------
[End Variable]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [Slug]
    ----------------------------------------------------------------*/
    const { slug } = useParams();
    /*--------------------------------------------------------------
    [Slug]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [useLocation]
    ----------------------------------------------------------------*/
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    }
    let query = useQuery(); // query.get("order_id")
    /*--------------------------------------------------------------
    [End useLocation]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Meta]
    ----------------------------------------------------------------*/
    let meta_title = 'Call';
    /*--------------------------------------------------------------
    [End Meta]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Route API]
    ----------------------------------------------------------------*/
    let route_api = route;
    /*--------------------------------------------------------------
    [End Route API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Route Path]
    ----------------------------------------------------------------*/
    let route_path = 'call';
    /*--------------------------------------------------------------
    [End Route Path]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Request Params]
    ----------------------------------------------------------------*/
    let request_params = 'call';
    /*--------------------------------------------------------------
    [End Request Params]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Private]
    ----------------------------------------------------------------*/
    let PRIVATE = true;
    /*--------------------------------------------------------------
    [End Private]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Pagination Offset]
    ----------------------------------------------------------------*/
    let pagination_offset = 20;
    /*--------------------------------------------------------------
    [End Pagination Offset]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [tour, set_tour] = useState(false);
    const [tab, set_tab] = useState(null);
    const [filter, set_filter] = useState(null);
    const [sub_filter, set_sub_filter] = useState(null);

    const [refresh, set_refresh] = useState(null);
    const [queue, set_queue] = useState(false)
    const [file, set_file] = useState(null);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [bamboo_update, set_bamboo_update] = useState('');
    const [bamboo_delete, set_bamboo_delete] = useState('');

    const [table_height, set_table_height] = useState(0);

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    const [end_element, set_end_element] = useState(null);
    
    const [pagination_active, set_pagination_active] = useState(1);
    const [path_client, set_path_client] = useState('')
    const [data, set_data] = useState(null);
    const [data_user, set_data_user] = useState(null);
    const [data_call_user, set_data_call_user] = useState(null);
    const [search, set_search] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [New State]
    ----------------------------------------------------------------*/
    const [test, set_test] = useState('')

    const [me, set_me] = useState(null)
    const [stream, set_stream] = useState(null)
    const [name, set_name] = useState('')
    const [uniquename, set_uniquename] = useState('')
    const [photo, set_photo] = useState('')

    const [chat, set_chat] = useState('')
    const [chat_overlay, set_chat_overlay] = useState(null)
    const [typing, set_typing] = useState(null)
    const [typing_toggle, set_typing_toggle] = useState(false)
    const [receiving_call_me, set_receiving_call_me] = useState(false)
    const [receiving_call_user, set_receiving_call_user] = useState(false)
	const [caller, set_caller] = useState('')
	const [caller_signal, set_caller_signal] = useState()
	const [call_accepted, set_call_accepted] = useState(false)
	const [call_ended, set_call_ended] = useState(false)
    const [id_to_call, set_id_to_call] = useState('')

    const my_video = useRef()
    const user_video = useRef()
	const connection_ref= useRef()
    /*--------------------------------------------------------------
    [End New State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Looping Input]
    ----------------------------------------------------------------*/
    const input = [
        {
            name : 'test',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: true,
            data: null
        },

        {
            name : 'submit',
            element : 'submit',
            text_transform : 'capitalize',
            submit_file: false
        }
    ]

    const input_obj = {
        test : test
    }
    /*--------------------------------------------------------------
    [End Looping input]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Ref]
    ----------------------------------------------------------------*/
    const ref_table_height = useRef(null)
    /*--------------------------------------------------------------
    [End Ref]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/
    const steps = [
        {
          selector: '.___step_1',
          content: 'Content 1',
        },
    ];
    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read = (pages, bambooUserParams) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (pagination_offset * pages) - pagination_offset : 0
        
        }

        if(queue === true){
            return
        }
        
        loading(true)
        set_queue(true)

        API_GET_REQUEST(`${route_api}/${route_path}/get__________?action=read_${request_params}`
            + '&bamboo_user=' + bambooUserParams
            + '&limit=' + pagination_offset
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            console_dev(`response ${request_params} read`, response.data)
            if(response.data.result == 'success'){
                set_data(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
            set_queue(false)
        })

	}

    const _read_user = (pages, bambooUserParams) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (pagination_offset * pages) - pagination_offset : 0
        
        }

        if(queue === true){
            return
        }
        
        loading(true)
        set_queue(true)

        API_GET_REQUEST(`forum/user/get__________?action=read`
            + '&bamboo_user=' + bambooUserParams
            + '&limit=' + pagination_offset
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            console_dev(`response forum user read`, response.data)
            if(response.data.result == 'success'){
                set_data_user(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
            set_queue(false)
        })

	}

    const _search = () => {

        if(queue === true){
            return
        }
        
        if(search.length > 3){

            set_queue(true)
    
            API_GET_REQUEST(`${route_api}/${route_path}/get__________?action=search_${request_params}`
                + '&bamboo_user=' + bamboo_user
                + '&search=' + search
            , 
            ).then((response) => {
                console_dev(`response ${request_params} search`, response.data)
                if(response.data.result == 'success'){
                    set_data(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
                set_queue(false)
            })

        }

    }

    const _uploads = (action) => {

        if(queue === true){
            return
        }
        
        loading(true)
        set_queue(true)

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("bamboo_user", bamboo_user);
        data.append("bamboo_update", bamboo_update);
        data.append("bamboo_delete", bamboo_delete);
        data.append("path_client", path_client);
        data.append("action", action);
        // new request --------------------------------
        data.append("test", test);
        
        input && input.map((x, i)=> {
            if(x.element !== 'submit' && x.element !== 'file'){
                data.append(x.name, eval(x.name))
            }
        })

        if(file !== null){
            file.map((item) => (
                data.append("file", item)
            ))
        }

        var config = {
            method: 'post',
            url: API_URL + `${route_api}/${route_path}/post__________`,
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                if(file !== null){
                    progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                }
            }
        };

        axios(config)
        .then((response) => {
            console_dev(`response ${request_params} uploads`, response.data)
            if(response.data.result === 'success'){
                _read(pagination_active, bamboo_user)
                set_file(null)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                set_path_client('')
                // update state ------------------
                set_test('')
                
                input.map((x, i)=> {
                    if(x.element !== 'submit'){
                        eval('set_' + x.name)('')
                    }
                })
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console_dev('catch', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
            set_queue(false)
		})

    }

    const _uploads_post = (params) => {

        if(queue === true){
            return
        }
        
        loading(true)
        set_queue(true)

		API_POST(`${route_api}/${route_path}/post__________`, {
            bamboo_user: bamboo_user,
            bamboo_update: bamboo_update,
            bamboo_delete: bamboo_delete,
            action: params,
            // new request ------------------------
            test: test,
            ...input_obj
		}).then((response) => {
            console_dev(`response ${request_params} uploads post`, response.data)
            if(response.data.result == 'success'){
                _read(pagination_active, bamboo_user)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                // update state ------------------
                set_test('')

                input.map((x, i)=> {
                    if(x.element !== 'submit'){
                        eval('set_' + x.name)('')
                    }
                })
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
            set_queue(false)
        })

	}
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Socket]
    ----------------------------------------------------------------*/
    const _join_room = (storageUserParams) => {

        socket.emit("call_join_room", {
            action: 'connect',
            room: storageUserParams.room,
            status: 'online',
            name: STORAGE_USER[0].name,
            uniquename: STORAGE_USER[0].uniquename,
            notice: STORAGE_USER[0].name + ' ' + 'Joined' 
        });
		
	}

    const _join_room_me = (storageUserParams) => {

        socket.emit("call_join_room", {
            action: 'connect',
            room: storageUserParams.room,
            status: 'online',
            name: storageUserParams.name,
            uniquename: storageUserParams.uniquename,
            notice: storageUserParams.name + ' ' + 'Joined' 
        });
		
	}

    const _chat_send = (dataParams) => {

        socket.emit("call_join_room", {
            room: dataParams.room,
            chat: chat
        });
		
	}

    const _chat_typing = (typing) => {

        if(chat.length > 0){

            socket.emit("call_join_room", {
                room: chat_overlay.room,
                name: STORAGE_USER[0].name,
                uniquename: STORAGE_USER[0].uniquename,
                typing: typing
            });

            return

        }else{

            if(chat_overlay){

                socket.emit("call_join_room", {
                    room: chat_overlay.room,
                    typing: ''
                });

            }

        }
		
	}
    /*--------------------------------------------------------------
    [End Socket]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    
    const _files_multiple = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        let data = [...event.target.files]
        
        if(data){

            console_dev('data', data)

            data.map((item, index) => {
                // console.log('item', data)
                if(item.size > 2048000){
                    return error('Ukuran File maxsimal 2MB')
                }else{
                    set_file([...data])
                }

            })

        }
        
	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        if(STORAGE_USER !== undefined){

            let storage_bamboo = STORAGE_USER[0].bamboo;
            let storage_bamboo_chain = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            set_bamboo_user(storage_bamboo)
            _join_room_me(STORAGE_USER[0])
            _read_user(1, storage_bamboo)

            set_name(STORAGE_USER[0].name)
            
        }else{

            // error('User Not Found')
        
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    if(PRIVATE === true){
        if(STORAGE_USER !== undefined){
            if(STORAGE_USER[0].level === 'guest'){
                history.push('/')
            }
        }else{
            history.push('/home')
            window.location.reload();
        }
    }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            _STORAGE_USER()
        }

    }, [refresh, search])

    useEffect(() => {

        if(ref_table_height.current){
            set_table_height(ref_table_height.current.clientHeight + 10)
        }

    }, [data])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    useEffect(() => {

		// navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
		// 	set_stream(stream)
		// 		my_video.current.srcObject = stream
		// })

	}, [])

    useEffect(() => {

        socket.on("call_join_room", (data) => {
            console_dev_line('----------------------------------------------------------');
            console_dev_line('@socket_id');
            console_dev_line('----------------------------------------------------------');
            console_dev_line(data.id)
			set_me(data.id)
		})

        socket.on("call_join_room", (data) => {
            console_dev_line('----------------------------------------------------------');
            console_dev_line('@call_join_room');
            console_dev_line('----------------------------------------------------------');
            console_dev_line(data)
		})

        socket.on("call_join_room_chat", (data) => {
            console_dev_line('----------------------------------------------------------');
            console_dev_line('@call_join_room_chat');
            console_dev_line('----------------------------------------------------------');
            console_dev_line(data)
        })

        socket.on("call_join_room_typing", (data) => {
            console_dev_line('----------------------------------------------------------');
            console_dev_line('@call_join_room_typing');
            console_dev_line('----------------------------------------------------------');
            console_dev_line(data)
            set_typing(data)	
        })

        socket.on("call_user", (data) => {
            console_dev_line('----------------------------------------------------------');
            console_dev_line('@call_user');
            console_dev_line('----------------------------------------------------------');
            console_dev_line(data)
            set_data_call_user(data)
            set_receiving_call_user(true)
			set_caller(data.from)
			set_name(data.name)
            set_uniquename(data.uniquename)
            set_photo(data.photo)
			set_caller_signal(data.signal)
		})

        socket.on("reject_call", (data) => {
            console.log('reject_call : ', data)
		})

    }, [])

    useEffect(() => {

        if(typing_toggle === true){
            _chat_typing('Typing ...')
        }else{
            _chat_typing('')
        }

	}, [typing_toggle])

    const _call_user = (params) => {

		const peer = new Peer({
			initiator: true,
			trickle: false,
			stream: stream
		})

		peer.on("signal", (data) => {
            console.log('data signal call user : ', data)
			socket.emit("call_user", {
				room: params.room,
				signal_data: data,
				from: me,
				name: name,
                uniquename: STORAGE_USER[0].uniquename,
                photo: API_SERVER + '/' + STORAGE_USER[0].path + '/' + STORAGE_USER[0].photo,
                notice: '',
                message: '',
			})
		})

	}

    const _reject_call = () => {
        
		const peer = new Peer({
			initiator: true,
			trickle: false,
			stream: stream
		})

		peer.on("signal", (data) => {
            console.log('data signal reject call : ', data)
			socket.emit("reject_call", { 
                signal: data, 
                to: caller,
                notice: 'Rejected',
                message: '', 
            })
		})

	}

    const answer_call =() =>  {

		set_call_accepted(true)

		const peer = new Peer({
			initiator: false,
			trickle: false,
			stream: stream
		})

		peer.on("signal", (data) => {
			socket.emit("answer_call", { signal: data, to: caller })
		})

		peer.on("stream", (stream) => {
			userVideo.current.srcObject = stream
		})

		peer.signal(callerSignal)
        
		connectionRef.current = peer

	}

    return (
        <div className="_lily_pad_h_d _container">

            {/*  Helmet ------------------------------------------------------------------ */}
            <Helmet>

                <meta name="description" content={`${meta_title}`}/>
                <title>{`${meta_title}`}</title>

            </Helmet>
            {/*  End Helmet -------------------------------------------------------------- */}

            {/*  Tour -------------------------------------------------------------------- */}
            <Tour steps={steps} isOpen={tour} onRequestClose={() => set_tour(false)} />
            <Tour disableKeyboardNavigation={['esc']} />
            {/*  End Tour ---------------------------------------------------------------- */}

            {/*  Header ------------------------------------------------------------------ */}
            <div className="_row _center_align _push_t_d">
                <div className="_column">
                    <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>{meta_title}</h1>
                </div>
            </div>
            
            <div className="_row _center_align _push_b_d">
                <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                <p className="_push_l_m">Panggilan Video dan Audio Gratis</p>
            </div>
            {/*  End Header --------------------------------------------------------------- */}

            <div className="_overflow_x">
                <div className="_row _center_align">
                    {
                        data_user && data_user.list.map((item, index) => {
                            // console.log(API_SERVER + '/' + item.path + '/' + item.photo)
                            return(
                                <div key={index} style={{marginRight: 16, cursor: 'pointer'}} onClick={() => {
                                    set_chat_overlay(item)
                                    _join_room(item)
                                }}>
                                    <div style={{position: 'relative', height: 70, width: 70, borderRadius: 70, backgroundColor: '#f5f5f5', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundImage: `url(${API_SERVER}/${item.path}/${item.photo})`}}>
                                    
                                    </div>
                                    <p style={{color: '#888', marginTop: 6, width: 70, fontSize: 10, textAlign: 'center', textOverflow: 'ellipsis', overflow: 'hidden'}}>@{item.uniquename}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            
            {
                STORAGE_USER &&
                <p className="_push_t_m"><span style={{color: '#888'}}>Hi</span> {STORAGE_USER[0].name}</p>
            }

            <div>
                <div className="_row_sync_2" style={{marginLeft: -10, marginRight: -10}}>
                    <div className="_column_sync_2">
                        {/* {stream &&  <video playsInline muted ref={my_video} autoPlay style={{ width: "100%" }} />} */}
                    </div>
                    <div className="_column_sync_2">
                        {/* <div className="video">
                            {callAccepted && !callEnded ?
                            <video playsInline ref={userVideo} autoPlay style={{ width: "100%"}} />:
                            null}
                        </div> */}
                    </div>
                </div>
                {/* <input
                    placeholder="ID to call"
                    onChange={(e) => set_id_to_call(e.target.value)}
                    value={id_to_call}
                />
                <button className="_btn" onClick={() => _call_user(id_to_call)}>
                    Call
                </button> */}

                {chat_overlay ? (
                    <div style={{position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, zIndex: 100, backgroundColor: '#fff', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}}>
                        <div className="_lily_pad_h_d _container">
                            <div style={{textAlign: 'center', marginTop: 50}}>
                                <div style={{position: 'relative', display: 'inline-block', marginBottom: 30, height: 250, width: 250, borderRadius: 250, backgroundColor: '#f5f5f5', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundImage: `url(${API_SERVER}/${chat_overlay.path}/${chat_overlay.photo})`}}>
                                    
                                </div>
                            </div>
                            <div className="_center_text">
                                <div style={{display: 'inline-block'}}>
                                    <div className="_row _center_align">
                                        <div onClick={() => _reject_call()} style={{cursor: 'pointer', position: 'relative', height: 50, width: 50, borderRadius: 60, backgroundColor: 'red', textAlign: 'center'}}>
                                            <div className="_position_middle">
                                                <ion-icon name="close-outline" style={{color: '#fff', fontSize: 26}}></ion-icon>
                                            </div>
                                        </div>
                                        <div onClick={() => _call_user(chat_overlay)} style={{cursor: 'pointer', position: 'relative', height: 60, width: 60, marginLeft: 20, marginRight: 20, borderRadius: 60, backgroundColor: 'seagreen', textAlign: 'center'}}>
                                            <div className="_position_middle">
                                                <ion-icon name="call-outline" style={{color: '#fff', fontSize: 30}}></ion-icon>
                                            </div>
                                        </div>
                                        <div style={{cursor: 'pointer', position: 'relative', height: 50, width: 50, borderRadius: 60, backgroundColor: '#aaa', textAlign: 'center'}}>
                                            <div className="_position_middle">
                                                <ion-icon name="chatbubble-outline" style={{color: '#fff', fontSize: 26}}></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*  Search -------------------------------------------------------------------- */}
                            <div className="_bb_search _push_b_d _push_t_d" style={{backgroundColor: 'transparent', borderRadius: 32}}>
                                <div className="_row _center_align">
                                    <ion-icon name="chatbubble-outline" style={{fontSize: 20}}></ion-icon>
                                    <div className="_column">
                                        <input 
                                            placeholder="Chat" 
                                            onChange={e => {
                                                set_chat(e.target.value)
                                                if(e.target.value.length > 0){
                                                    set_typing_toggle(true)
                                                }else if(e.target.value.length === 0){
                                                    set_typing_toggle(false)
                                                }
                                            }}
                                            value={chat}
                                        />
                                    </div>
                                    <div style={{cursor: 'pointer', display: 'inline-block'}} onClick={() => {_chat_send(chat_overlay)}}>
                                        <ion-icon name="send-outline" style={{fontSize: 20, marginBottom: -4}}></ion-icon>
                                    </div>
                                </div>
                            </div>
                            {
                                typing.typing &&
                                STORAGE_USER && STORAGE_USER[0].uniquename !== typing.uniquename &&
                                <p className="_push_t_s">{typing.name} {typing.typing}</p>
                            }
                            {/*  End Search ---------------------------------------------------------------- */}
                            <div style={{textAlign: 'center', marginTop: 50}}>
                                <div onClick={() => set_chat_overlay(null)} style={{cursor: 'pointer', position: 'relative', display: 'inline-block', marginTop: 30, height: 50, width: 50, borderRadius: 50, backgroundColor: '#f5f5f5'}}>
                                    <div className="_position_middle">
                                        <ion-icon name="close-outline" style={{fontSize: 20}}></ion-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}

                {
                    STORAGE_USER && data_call_user &&
                    receiving_call_user && !call_accepted ?
                        <div style={{position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, zIndex: 100, backgroundColor: '#fff', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundImage: STORAGE_USER[0].uniquename !== data_call_user.uniquename ? `url(${photo})` : `url(${API_SERVER}/${chat_overlay.path}/${chat_overlay.photo})`}}>
                            <div style={{position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.8)'}}>

                            </div>
                            <div className="_position_middle">
                                {
                                    STORAGE_USER[0].uniquename !== data_call_user.uniquename ?
                                        <>
                                            <p style={{color: '#eee'}}>@{uniquename}</p>
                                            <h2 className="_push_b_l" style={{color: '#fff'}}>{name} is calling...</h2>
                                        </>
                                    :
                                        <>
                                            <p style={{color: '#eee'}}>@{chat_overlay.uniquename}</p>
                                            <h2 className="_push_b_l" style={{color: '#fff'}}>Calling {chat_overlay.name}</h2>
                                        </>
                                }
                                {/* <button className="_btn" onClick={answer_call}>
                                    Answer
                                </button> */}
                                <div style={{position: 'relative', marginBottom: 30, height: 250, width: 250, borderRadius: 250, backgroundColor: '#f5f5f5', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundImage: STORAGE_USER[0].uniquename !== data_call_user.uniquename ? `url(${photo})` : `url(${API_SERVER}/${chat_overlay.path}/${chat_overlay.photo})`}}>
                                    
                                </div>
                                <div className="_row _center_align">
                                    <div onClick={() => _reject_call()} style={{cursor: 'pointer', position: 'relative', height: 50, width: 50, borderRadius: 60, backgroundColor: 'red', textAlign: 'center'}}>
                                        <div className="_position_middle">
                                            <ion-icon name="close-outline" style={{color: '#fff', fontSize: 26}}></ion-icon>
                                        </div>
                                    </div>
                                    <div style={{cursor: 'pointer', position: 'relative', height: 60, width: 60, marginLeft: 20, marginRight: 20, borderRadius: 60, backgroundColor: 'seagreen', textAlign: 'center'}}>
                                        <div className="_position_middle">
                                            <ion-icon name="call-outline" style={{color: '#fff', fontSize: 30}}></ion-icon>
                                        </div>
                                    </div>
                                    <div style={{cursor: 'pointer', position: 'relative', height: 50, width: 50, borderRadius: 60, backgroundColor: '#aaa', textAlign: 'center'}}>
                                        <div className="_position_middle">
                                            <ion-icon name="chatbubble-outline" style={{color: '#fff', fontSize: 26}}></ion-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    : 
                        null
                }

            </div>
            
        </div>
    );

}

export default Screen;